/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightCheckoutPrice
 */
export interface FlightCheckoutPrice {
    /**
     *
     * @type {number}
     * @memberof FlightCheckoutPrice
     */
    totalAmount: number;
    /**
     *
     * @type {number}
     * @memberof FlightCheckoutPrice
     */
    taxAmount: number | null;
    /**
     *
     * @type {string}
     * @memberof FlightCheckoutPrice
     */
    currency: string;
}

/**
 * Check if a given object implements the FlightCheckoutPrice interface.
 */
export function instanceOfFlightCheckoutPrice(value: object): value is FlightCheckoutPrice {
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('taxAmount' in value) || value['taxAmount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function FlightCheckoutPriceFromJSON(json: any): FlightCheckoutPrice {
    return FlightCheckoutPriceFromJSONTyped(json, false);
}

export function FlightCheckoutPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightCheckoutPrice {
    if (json == null) {
        return json;
    }
    return {

        'totalAmount': json['total_amount'],
        'taxAmount': json['tax_amount'],
        'currency': json['currency'],
    };
}

export function FlightCheckoutPriceToJSON(json: any): FlightCheckoutPrice {
    return FlightCheckoutPriceToJSONTyped(json, false);
}

export function FlightCheckoutPriceToJSONTyped(value?: FlightCheckoutPrice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'total_amount': value['totalAmount'],
        'tax_amount': value['taxAmount'],
        'currency': value['currency'],
    };
}
